<template>
  <div
    class="m-empty-data"
    :class="[size,derection]"
  >
    <img
      v-if="hasImage"
      :src="imgUrl"
      alt="empty-data-image"
      class="empty-img"
    >
    <div class="empty-text">
      <slot>
        <p>
          {{ text }}
        </p>
      </slot>
    </div>
  </div>
</template>

<script>
import { NO_MATCHES_AVAILABLE } from '@ms/config/message.js'

export default {
  name: 'Empty',
  props: {
    text: {
      type: String,
      default: NO_MATCHES_AVAILABLE
    },
    derection: {
      type: String,
      default: 'vertical' // horizontal  vertical
    },
    // 尺寸，默认 normal, 支持 small
    size: {
      type: String,
      default: 'normal'
    },
    hasImage: {
      type: Boolean,
      default: true
    },
    showColorfullImg: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    imgUrl() {
      return this.derection === 'vertical' || this.showColorfullImg ? require('./imgs/empty.png') : require('./imgs/empty-gray.png')
    }
  }
}
</script>

<style lang="scss">
.m-empty-data {
  display: flex;
  max-width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 0;
  margin: 0 auto;
  color: #fff;
  font-size: 14px;
  text-align: center;

  .empty-img {
    width: 140px;
    margin-bottom: 10px;
  }

  .empty-text {
    color: #999;
    font-family: Roboto;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    white-space: break-word;
  }

  &.horizontal {
    width: 75%;
    flex-direction: row;

    .empty-img {
      width: 80px;
      margin: 0;
    }

    .empty-text {
      margin-left: 20px;
      text-align: left;
    }
  }

  &.small {
    width: 150px;
    padding: 21px 0;
    margin: 0 auto;

    .empty-img {
      width: auto;
      height: 74px;
      margin-bottom: 10px;
    }
  }
}
</style>
